"use client";

import { useEffect, useState } from "react";

export function SiteFooter() {
  const [lastPushDate, setLastPushDate] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchLastGlobalPush() {
      try {
        const res = await fetch(
          "https://api.github.com/users/Jeelislive/repos?sort=updated&per_page=1"
        );
        if (!res.ok) throw new Error("GitHub API error");
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0 && data[0].pushed_at) {
          const pushedAt = new Date(data[0].pushed_at);
          const formatted = pushedAt.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
          setLastPushDate(formatted);
        } else {
          setError("No push data");
        }
      } catch (err) {
        console.error(err);
        setError("Unavailable");
      }
    }
    fetchLastGlobalPush();
  }, []);

  return (
    <footer className="max-w-screen overflow-x-hidden px-2">
      <div className="screen-line-before mx-auto border-x border-edge pt-4 md:max-w-3xl">
        <p className="mb-1 px-4 text-center font-mono text-sm text-balance text-muted-foreground">
          Coded faster than a Red Bull pit stop 🏎️
        </p>

        <p className="mb-4 px-4 text-center font-mono text-sm text-balance text-muted-foreground">
          I last pushed code on{" "}
          <strong>
            {lastPushDate ? lastPushDate : error ? error : "Loading..."}
          </strong>.
        </p>
      </div>
      <div className="pb-[env(safe-area-inset-bottom,0px)]">
        <div className="flex h-2" />
      </div>
    </footer>
  );
}
